module.exports = __webpack_public_path__ + "static/media/recharge-method-payment.4136ac0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/recharge-method-payment.svg
// module id = 2892
// module chunks = 0